export default __webpack_public_path__ + "static/media/super admin.323afeb8.jpg";